export interface CompanyUrls {
  websiteUrl: string | undefined;
  linkedinUrl: string | undefined;
}

function readUrl(profile: Record<string, unknown>, key: string): string | undefined {
  const value = profile[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/**
 * True when the URL's host is (or is a subdomain of) linkedin.com. The
 * enrichment pipeline stores companyUrl = the LinkedIn company page and
 * websiteUrl = the real site (FLOSEAI-599) — companyUrl must not be treated
 * as the website when it actually points at LinkedIn.
 */
function isLinkedInUrl(url: string | undefined): boolean {
  if (!url) return false;
  try {
    const host = new URL(url).hostname.toLowerCase().replace(/^www\./, '');
    return host === 'linkedin.com' || host.endsWith('.linkedin.com');
  } catch {
    return false;
  }
}

export function readCompanyUrls(
  customFields: Record<string, unknown> | null | undefined,
): CompanyUrls {
  const profile = customFields?.companyProfile;
  if (!profile || typeof profile !== 'object') {
    return { websiteUrl: undefined, linkedinUrl: undefined };
  }
  const record = profile as Record<string, unknown>;
  const companyUrl = readUrl(record, 'companyUrl');
  const companyIsLinkedIn = isLinkedInUrl(companyUrl);

  return {
    websiteUrl: readUrl(record, 'websiteUrl') ?? (companyIsLinkedIn ? undefined : companyUrl),
    linkedinUrl:
      readUrl(record, 'companyLinkedinUrl') ?? (companyIsLinkedIn ? companyUrl : undefined),
  };
}
